angular.module('impactx.warnings').controller('ConfirmSingleWarningsCtrl', [
    '$scope',
    '$mdDialog',
    'warningList',
    'proceedLabel',
    'abortLabel',
    'warningLabel',
    'themeFactory',
    ConfirmSingleWarningsCtrl]);

function ConfirmSingleWarningsCtrl($scope, $mdDialog, warningList, proceedLabel, abortLabel, warningLabel, themeFactory) {
    var positionInArray = 0;
    $scope.currentWarning = {};
    $scope.currentWarning.value = warningList[0];
    $scope.proceedLabel = proceedLabel;
    $scope.abortLabel = abortLabel;
    $scope.warningLabel = warningLabel;
    $scope.theme = themeFactory.getTheme();
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };
    this.proceed = function ()
    {
        if (positionInArray + 1 >= warningList.length)
        {
            $mdDialog.hide();
        }
        else
        {
            positionInArray++;
            $scope.currentWarning.value = warningList[positionInArray];
        }
    };
}